<template>
	<transition name="slide-fade">
		<div class="loading-bar"></div>
	</transition>
</template>

<style>
.loading-bar {
	height: 2px;
	width: calc(100vw - 280px);
	z-index: 99;
	overflow: hidden;
	position: absolute;
	right: 0;
}

.loading-bar:before {
	will-change: transform;
	display: block;
	position: absolute;
	content: '';
	transform: translateX(100%);
	width: calc(100vw - 280px);
	height: 2px;
	/*background: linear-gradient(to right, #31DEDC 0%, #18D9C3 50%,#00D5AA 99%,#00D5AA 100%);*/
	background: #31dedc;
	animation: loading 2s linear infinite;
}

@keyframes loading {
	from {
		transform: translateX(-100%);
	}
	to {
		transform: translateX(100%);
	}
}
</style>
